import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyReportsVersionWorkloadRoute: InvariantJiraRoute = {
	name: 'legacy-reports-version-workload-report',
	path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
	query: ['reportKey=com.atlassian.jira.plugins.jira-software-plugin:version-workload-report'],
};
